import { Button, Menu, MenuItem, Navbar, H3 } from '@blueprintjs/core';
import { Popover2 } from '@blueprintjs/popover2';
import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import logo from '../../../assets/logo.png';
import logoWhite from '../../../assets/logo.png';
import { RootState } from '../../../stores';
import { setDarkMode } from '../../../stores/ui';
import NoNotif from '../../elements/NoNotif';
import useLogout from '../../hooks/useLogout';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import HeaderContext from './HeaderContext';
import styles from './header.module.css';

interface Props {
  className?: string,
  collapse?: boolean,
  onMenuClick?: () => void,
}

const Header: React.FC<Props> = ({ className, collapse, onMenuClick }) => {
  const { content } = useContext(HeaderContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { dark } = useSelector((s: RootState) => s.ui);
  const { name } = useSelector((s: RootState) => s.user).user;
  const { width } = useWindowDimensions();
  const logout = useLogout();
  const isMobile = width <= 767;

  return (
    <div className={className}>
      <Navbar>
        {
          isMobile &&
          <Navbar.Group className={styles.menuButton}>
            <Button minimal icon="menu" onClick={onMenuClick} aria-label="Buka menu" />
          </Navbar.Group>
        }

        {
          (!isMobile || content == null) &&
          <Navbar.Group className={collapse ? styles.collapse : styles.expand}>
            <img
              className={styles.logo}
              height={24}
              src={dark ? logoWhite : logo}
              alt="Pemerintahan Kabupaten Tangerang"
            />
            {(collapse === false || isMobile) && <H3>SIPERINCI</H3>}
          </Navbar.Group>
        }

        <Navbar.Group className={styles.context}>
          {content}
        </Navbar.Group>

        <Navbar.Group align="right">
          <Button
            minimal
            icon={dark ? 'flash' : 'moon'}
            title={dark ? 'Light mode' : 'Dark mode'}
            aria-label={dark ? 'Light mode' : 'Dark mode'}
            onClick={() => dispatch(setDarkMode(!dark))}
          />

          {
            !isMobile &&
            <>
              <Popover2
                className={styles.desktop}
                content={<NoNotif />}
                interactionKind="click"
                placement="bottom-end"
                renderTarget={({ isOpen, ref, ...targetProps }) => (
                  <Button {...targetProps} minimal elementRef={ref!} icon="notifications" />
                )}
              />
              <Navbar.Divider className={styles.desktop} />

              <Popover2
                className={styles.desktop}
                content={
                  <Menu>
                    <MenuItem icon="user" text="Profile" onClick={()=>navigate('/profile')} />
                    <MenuItem icon="log-out" text="Log out" onClick={logout} />
                  </Menu>
                }
                interactionKind="click"
                placement="bottom-end"
                renderTarget={({ isOpen, ref, ...targetProps }) => (
                  <Button {...targetProps} minimal elementRef={ref!} icon="user" text={name} />
                )}
              />
            </>
          }
        </Navbar.Group>
      </Navbar>
    </div>
  );
};

export default Header;
